export default (seconds: number): string => {
  const h = Math.floor(seconds / 3600);
  const m = Math.floor((seconds % 3600) / 60);
  const s = Math.floor(seconds % 60);
  return [h, m, s]
    .map((unit) => String(unit).padStart(2, '0'))
    .filter((unit, index) => unit !== '00' || index > 0) // Skip leading hours if 00
    .join(':');
};
